// media
import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import Jazzicon, { jsNumberForAddress } from 'react-jazzicon';

import { Row, Col, Space, Drawer, Card } from 'antd';

export default function MediaCreators(props) {
  
  const data = props.data;

  return (
    <>
    <div className='m-0 p-0'>
      <Row className="" gutter={{ xs: 12, sm: 12, md: 12, lg: 12 }}>

      {data && data.map((item, i) => (
        <Col className="m-0 p-0 mb-2" xs={{span:24}} md={{span:8}} key={i}>
          
          <div className='py-1 hilite border p-1 rounded-wd cursor' key={i}>
              <Row justify="start" align="middle" wrap={false}>
                <Col flex="none" className=""  style={{lineHeight:'0rem'}}>
                  <Jazzicon diameter={33} seed={jsNumberForAddress(item.user)} />
                </Col>
                <Col flex="auto" className="text-start">
                    <p className="m-0 ms-1 p-0">{item.name}</p>
                    <p className="m-0 ms-1 p-0 text-color-tone text-small" style={{lineHeight:'0.9rem'}}>{item.role === 'team' ? 'contributor' : item.role}</p>
                </Col>
              </Row>
            
          </div>
        </Col>
      ))}
      </Row>
    </div>
    </>
    )
  }